import clsx from "clsx";

const OptionsSelector = ({
	options,
	selected,
	onSelect,
	className,
	detached = false,
}) => {
	return (
		<div className="overflow-hidden rounded-lg flex justify-start items-center">
			<div
				className={clsx(
					"flex items-center overflow-x-auto",
					className,
					detached ? "gap-2" : "border shadow-sm rounded-lg ",
				)}
			>
				{options.map((opt, i) => (
					<button
						key={opt.value}
						className={`h-full text-sm text-nowrap block ${
							selected === opt.value
								? "text-indigo-800 font-semibold bg-indigo-100"
								: ""
						} ${
							detached ? "border shadow-sm rounded-lg py-2 px-3" : "py-2.5 px-4"
						} ${detached && selected === opt.value ? "border-indigo-300" : ""}`}
						onClick={() => onSelect(opt.value)}
					>
						{opt.label}
					</button>
				))}
			</div>
		</div>
	);
};

export default OptionsSelector;
